import { BaseContainerModel } from '../../base-container.model';
import { Bl_inv_stock_replenishment_template_filter_category_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_template_filter_category.model';

export class StockReplenishmentTemplateFilterCategoryModel extends BaseContainerModel {
  bl_inv_stock_replenishment_template_filter_category: Bl_inv_stock_replenishment_template_filter_category_RowClass = new Bl_inv_stock_replenishment_template_filter_category_RowClass();
}
